import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Lobby } from './pages/Lobby';
import { Game } from './pages/Game';
import { Voting } from './pages/Voting';
import { Reveal } from './pages/Reveal';
import { GameProvider } from './state/GameProvider';
import { DebugPanel } from './components/DebugPanel';

export function App() {
  return (
    <GameProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lobby/:code" element={<Lobby />} />
        <Route path="/game/:code" element={<Game />} />
        <Route path="/vote/:code" element={<Voting />} />
        <Route path="/reveal/:code" element={<Reveal />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <DebugPanel />
    </GameProvider>
  );
}
